import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AgentService } from '@core/services/agent.service';
import { CommonService } from '@core/services/common.service';
import { DataService } from '@core/services/data.service';
import { LocaleService } from '@core/services/locale.service';
import { PolicyService } from '@core/services/policy.service';
import { HomeComponent } from '../home.component';
import { LoadingService } from '@core/services/loading.service';

@Component({
    selector: 'app-home-individual',
    templateUrl: './home-individual.component.html',
    styleUrls: ['./home-individual.component.scss'],
    standalone: false
})
export class HomeIndividualComponent extends HomeComponent implements OnInit, AfterViewInit {

    constructor(
        public commonService: CommonService,
        protected dataService: DataService,
        protected router: Router,
        protected localeService: LocaleService,
        protected agentService: AgentService,

        private policyService: PolicyService,
        protected loadingService: LoadingService
    ) {
        super(commonService, dataService, router, localeService, agentService, loadingService);
        this.loggedUser = this.getLoggedUser();
    }

    ngOnInit(): void {
        this.policyService.getActivePolicies().subscribe(policies => {
            if (this.loggedUser.SetPrefferedAgentPopup == false || this.loggedUser.SetPrefferedAgentPopup == null) {
                let newPolicies = [];
                let lastLogin = new Date(this.loggedUser.lastLogin).getTime();
                for (let i = 0; i < policies.length; i++) {
                    let pBegin = (new Date(policies[i].beginDate).getTime());
                    if (lastLogin < pBegin && pBegin < (new Date().getTime())) {
                        newPolicies.push(policies[i].policyNumber);
                    }
                }

                if (newPolicies.length > 0) {
                    let notfound = true;
                    for (let i = 0; i < newPolicies.length; i++) {

                        // searching agents assigned to policy
                        this.agentService.getAgentsForPolicy(newPolicies[i]).subscribe(agents => {
                            if (agents) {
                                for (let j = 0; j < agents.list.length; j++) {
                                    if (this.loggedUser.prefferedAgent != null && agents.list[j].agentId == this.loggedUser.prefferedAgent.agentId) {
                                        notfound = false;
                                    }
                                }
                            }
                        });

                        if (!notfound) {
                            break;
                        }
                    }

                    // if preffered agent is not in agent list
                    if (notfound) {
                        this.agentService.setPrefferedAgentComponentInit();
                    }
                }
            }

            this.groupPolicies(policies);
        });

    }

    toggleLoadMore(): void {
        this.loadMoreExpanded = !this.loadMoreExpanded;
    }


    ngAfterViewInit() {

        this.commonService.AgentSourceShowAlert.subscribe((x) => {
            if (x) {
                this.commonService.agentSourceMsg();
                this.commonService.hideAlertAgentSource();
                this.commonService.AgentSourceShowAlert.complete();
            }
        });

    }


}